/*
 * Copyright (c) 2021 WIT Software. All rights reserved.
 *
 * WIT Software Confidential and Proprietary information. It is strictly forbidden for 3rd parties to modify, decompile,
 * disassemble, defeat, disable or circumvent any protection mechanism; to sell, license, lease, rent, redistribute or
 * make accessible to any third party, whether for profit or without charge.
 *
 */

import React from 'react';

interface Props {
  bemBlock: string;
  isActive?: boolean;
  action: () => void;
}

export default React.memo(({ isActive, action, bemBlock }: Props) => {
  return isActive ? (
    <div id={`${bemBlock}_closeButton`} className="close-wrapper" onClick={action}>
      <span className="close-icon" />
    </div>
  ) : null;
});
